import Vue from "vue";
import VueRouter from "vue-router";
import HomeApp from "../views/HomeApp.vue";
import startApp from "../views/startApp.vue";
import productApp from "../views/productApp.vue";
import categoryApp from "../views/categoryApp.vue";
import cartApp from "../views/cartApp.vue";
import favoriteApp from "../views/favoriteApp.vue";
import ordersApp from "../views/ordersApp.vue";
import orderApp from "../views/orderApp.vue";
import notFound from "../views/notFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "404",
    component: notFound,
  },
  {
    path: "/start",
    name: "start",
    component: startApp,
  },
  {
    path: "/",
    name: "home",
    component: HomeApp,
  },
  {
    path: "/product/:id",
    name: "product",
    component: productApp,
  },
  {
    path: "/category/:type",
    name: "category",
    component: categoryApp,
  },
  {
    path: "/cart",
    name: "cart",
    component: cartApp,
  },
  {
    path: "/favorite",
    name: "favorite",
    component: favoriteApp,
  },
  {
    path: "/orders",
    name: "orders",
    component: ordersApp,
  },
  {
    path: "/order/:id",
    name: "order",
    component: orderApp,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.name == "product") {
      window.scrollTo({
        top: 0,
        left: 0,
      });
    } else if (savedPosition) {
      window.scrollTo({
        top: savedPosition.y,
        left: savedPosition.x,
      });
    }
  },
  routes,
});

export default router;
